import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function PromiseSection() {
  return <section className="py-20 md:py-32 bg-cream relative overflow-hidden" data-id="element-318">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10" data-id="element-319">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} data-id="element-320">
          <div className="flex justify-center mb-6" data-id="element-321">
            <div className="w-16 h-16 bg-sage-100 rounded-full flex items-center justify-center" data-id="element-322">
              <Sparkles className="text-sage-700" size={32} data-id="element-323" />
            </div>
          </div>

          <h2 className="text-3xl md:text-5xl font-bold mb-8 text-charcoal" data-id="element-324">
            Presentamos: <br className="md:hidden" data-id="element-325" />
            <span className="text-sage-700" data-id="element-326">Menopause Reset</span> <br data-id="element-327" />
            El Programa Integral.
          </h2>

          <div className="w-24 h-1 bg-sage-600 mx-auto mb-8 rounded-full opacity-50" data-id="element-328"></div>

          <p className="text-xl md:text-2xl text-charcoal-light leading-relaxed font-serif italic" data-id="element-329">
            "He creado este programa de 15 módulos para que dejes de adivinar.
            No es una dieta de hambre. Es un manual de supervivencia para
            regular el cortisol, equilibrar tus hormonas y volver a sentirte
            ligera, clara y en control."
          </p>
        </motion.div>
      </div>

      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-330">
        <div className="absolute top-[-10%] left-[-5%] w-96 h-96 bg-sage-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-331"></div>
        <div className="absolute bottom-[-10%] right-[-5%] w-96 h-96 bg-sage-100 rounded-full mix-blend-multiply filter blur-3xl opacity-30" data-id="element-332"></div>
      </div>
    </section>;
}